import React, { useEffect } from 'react';
import { useHotel } from '../context/HotelContext';

const removeInitialLoader = () => {
  const loader = document.getElementById('root-loader');
  if (loader) loader.remove();
};

const HotelGuard = ({ children }) => {
  const { loading, error, hotel } = useHotel();

  useEffect(() => {
    if (!loading) removeInitialLoader();
  }, [loading]);

  if (loading) return null;

  if (error || !hotel) {
    const message = error || 'Unable to load hotel information. Please try again later.';
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: '#ffffff',
        fontFamily: 'sans-serif',
      }}>
        <p style={{ fontSize: '1.125rem', color: '#374151', textAlign: 'center', maxWidth: 480, padding: '2rem', margin: 0 }}>
          {message}
        </p>
      </div>
    );
  }

  return children;
};

export default HotelGuard;
